{
  "w": 28,
  "h": 22,
  "rows": [
    "............................",
    "........WWWWWWWWWWWW........",
    ".......KGGCCCKKCCCGGK.......",
    ".......KGGWCCKKCCWGGK.......",
    "......GKGCCCCKKCCCCGKG......",
    ".....GGKCCCCCKKCCCCCKGG.....",
    ".....GGKCCCCCKKCCCCCKGG.....",
    "....GGGKcccccKKcccccKGGG....",
    "...GGGcKcccccKKcccccKcGGG...",
    "...GKKKKKKKKKKKKKKKKKKKKG...",
    "..GGGGGGGGGGGGGGGGGGGGGGGG..",
    ".GGGGGGGGGGGGGGGGGGGGGGGGGG.",
    ".GGGGGGGGGGGGGGGGGGGGGGGGGG.",
    "GGGGGGGGGGGGGGGGGGGGGGGGGGGG",
    "GGKKKKKKKKKKKKKKKKKKKKKKKKGG",
    "GGKKKKKKKKKKKKKKKKKKKKKKKKGG",
    "RRKggggggggggKKggggggggggKRR",
    "RRggggggggggWWWWggggggggggRR",
    "GGKKKKKggggggggggggggKKKKKGG",
    "KWKKKKKKKKKKKKKKKKKKKKKKKKWK",
    "...KKKK..............KKKK...",
    "............................"
  ],
  "legend": {
    "K": "C.BLACK",
    "G": "C.B_GREEN",
    "g": "C.GREEN",
    "C": "C.B_CYAN",
    "c": "C.CYAN",
    "W": "C.B_WHITE",
    "R": "C.RED"
  }
}
